import { open, openUrl } from './open';

/**
 * Browser-global entry for the CDN-hosted build (Stripe.js-style). Bundled by
 * esbuild into a single self-contained `playsteady.js` and served from the PlaySteady CDN
 * (`https://js.playsteady.io/v1/playsteady.js`). Partners load it with a `<script>`
 * tag and use the `window.PlaySteady` global — they never `npm install` this package
 * (it stays private; npm is the monorepo source + types only).
 *
 *   <script src="https://js.playsteady.io/v1/playsteady.js"></script>
 *   <script>
 *     PlaySteady.open({ token: clientSecret, onSuccess, onCancel });
 *   </script>
 *
 * Note: the CDN origin (`js.…`) is NOT the embed-surface origin (`app.…`), so
 * `open()` defaults `appUrl` to the production surface (see `open.ts`); sandbox /
 * self-hosted callers pass `appUrl` explicitly.
 */
const PlaySteady = { open, url: openUrl } as const;

declare global {
  interface Window {
    PlaySteady: typeof PlaySteady;
  }
}

if (typeof window !== 'undefined') {
  window.PlaySteady = PlaySteady;
}

export { PlaySteady };
